import { useContext } from "react";
import { JourneysContext } from "apps/journeys/context/journeys-context";
import JourneysTaskTableRow from "./task-row/journeys-task-table-row";
import JourneysTaskTableHeader from "./journeys-task-table-header";
import SelectedTaskDetails from "./selected-task/selected-task-details";

const JourneysTaskTable = () => {
  const { journeySteps } = useContext(JourneysContext);

  return (
    <div className="journeys-task-table--container">
      <JourneysTaskTableHeader />
      <div className="journeys-task-table--body">
        <div className="journeys-task-table--body--left">
          {journeySteps && journeySteps.map((step) => <JourneysTaskTableRow key={`task-${step.id}`} step={step} />)}
        </div>
        <div className="journeys-task-table--body--right">
          <SelectedTaskDetails />
        </div>
      </div>
    </div>
  );
};

export default JourneysTaskTable;
